// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__E+NRr","dadosUsuario":"OptionSelect_dadosUsuario__cX3st","focado":"OptionSelect_focado__ZEIR2"};